import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "defaultValue",
})
export class DefaultValuePipe implements PipeTransform {
  transform(value: any, defaultValue: any = "-") {
    return value !== null && value !== undefined ? value : defaultValue;
  }
}
